export default "__VITE_ASSET__CSMXR2Gl__"